var site = site || {};

(function ($) {
  Drupal.behaviors.sppCrossSellsV2 = {
    attached: false,
    isMobile: false,
    attach: function (context) {
      var self = this;
      if (self.attached) {
        return;
      }
      self.attached = true;
      self.isMobile = Unison.fetch.now().name === 'small';

      var $template = $('.js-spp-cross-sells-v2', context);
      var $skuCard = $('.js-sku-card', $template);
      var $grid = $('.js-product-grid-products--carousel', $template);
      var $items = $('.js-cross-sells-grid-item', $grid);
      var $productImageContainerTop = $('.js-product-brief-image-container-top', $items);
      var $productHeadline = $('.js-product-brief-headline', $items);
      var $productShortDesc = $('.js-product-brief-short-desc', $items);
      var hasNoDescription = $template.hasClass('js-spp-cross-sells-full');
      var carouselSlidesSettings = {
        dots: {
          dotsToShow: true,
        },
        desktop: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
        tablet: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
        mobile: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      };
      var carouselSlidesSettingsFull = {
        dots: {
          dotsToShow: true,
        },
        desktop: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
        tablet: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
        mobile: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      };

      if ($grid.length > 0) {
        if (hasNoDescription) {
          site.productCarousel.init($grid, carouselSlidesSettingsFull);
        } else {
          site.productCarousel.init($grid, carouselSlidesSettings);
        }
      }

      // @todo see if we need to keep this, or let product_brief_v2 handle this internally
      // duped from bb_base/template_api/editorial/editorial_grid_products_v1/src/editorial_grid_products_v1.js
      // this will be executed only when sku card is enabled in CMS

      if ($skuCard.length > 0) {
        $skuCard.each(function () {
          var $this = $(this);
          var shade = $this.data('shade-name');

          // removing shade numbers (skin foundation shades)
          shade = shade.replace(/[0-9.()]+$/g, '');
          var shadeName = shade.replace(/ /g, "_");
          var $anchorLink = $this.find('.js-sku-image-link');

          $anchorLink.each(function () {
            var $thisLink = $(this);
            var oldLink = $thisLink.attr('href');
            var newLink = oldLink + '#/shade/' + shadeName;

            $thisLink.attr('href', newLink);
          });
        });
      }

      if (!self.isMobile && $items.length > 0) {
        $(window).on('load.productGrid resize-debounced.productGrid', function() {
          self.equalHeight($items);
          self.equalHeight($productImageContainerTop);
          self.equalHeight($productHeadline);
          self.equalHeight($productShortDesc);
        });
      }
    },
    equalHeight: function($els) {
      var $productBriefs = $els.find('.js-product-brief-v3');
      var $tallest;
      var tallestHeight;
      var hoverTallestHeight;
      if (!$els.length) {
        return;
      }
      $els.height('auto');
      $productBriefs.height('auto');
      $tallest = $(_.max($els, function(el) { return $(el).height(); }));

      if ($tallest.length > 0) {
        tallestHeight = $tallest.height();
        if ($productBriefs.length > 0 && $els.hasClass('js-cross-sells-grid-item')) {
          $productBriefs.addClass('hover');
          hoverTallestHeight = $(_.max($els, function(el) { return $(el).height(); })).height();
          $productBriefs.removeClass('hover');
          tallestHeight = hoverTallestHeight > tallestHeight ? hoverTallestHeight : tallestHeight;
          if (tallestHeight > 0) {
            $productBriefs.css('height', tallestHeight);
          }
          return;
        }
        if (tallestHeight > 0) {
          $els.css('height', tallestHeight);
        }
      }
    },
  };
})(jQuery);
